import { useMutation, useQueryClient } from '@tanstack/react-query';

import { endpoints } from 'global/endpoints';
import http from 'utils/http';
import toaster from 'utils/toaster';

export interface ISaveNotificationSettings {
  employee_clock_out_of_bounds: boolean;
  schedule_notification_by_email: boolean;
  schedule_notification_by_mobile: boolean;
  overtime_notification: boolean;
  automatic_clockout: boolean;
  overtime_threshold: number;
  clockout_threshold: number;
  send_reminder_to_take_breaks: boolean;
  break_reminder_after_x_hours: number;
  send_reminder_for_no_show: boolean;
  send_reminder_for_late_clock_in: boolean;
  clock_in_reminder: {
    time: number;
    reminder_mobile: boolean;
    reminder_email: boolean;
  };
  clock_out_reminder: {
    time: number;
    reminder_mobile: boolean;
    reminder_email: boolean;
  };
  cali_send_rest_break_reminder_after_hrs?: string;
  cali_send_meal_break_reminder_after_hrs?: string;
}

const saveNotificationSettings = (postData: ISaveNotificationSettings) => {
  return http().post(endpoints.companySettings.notificationSettings, postData);
};

export function useSaveNotificationSettings() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: saveNotificationSettings,
    onSuccess: (data: any) => {
      queryClient.invalidateQueries({ queryKey: ['fetchUserDetails'] });
      if (data.message) {
        toaster.success({ description: data.message });
      }
    },
  });
}
